import styled from 'styled-components'

export const Link = styled.a.attrs(props => ({
  href: (props.href || '').replace(/^\//, site_path_root)
}))``;
